import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicDropdown, BaasicInput } from 'core/components';
import { translate } from 'core/utils';

function AddExistingProductModalContentTemplate({ addExistingProductModalContentViewStore, t }) {
	const {
		addExistingProductForm,
		isSaveClicked,
		goBackToProductPartTypeSelection,
		productDropdownStore,
	} = addExistingProductModalContentViewStore;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={addExistingProductForm.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('PRODUCTDETAILVIEW.ADDPRODUCTPARTMODAL.ADDEXISTINGPRODUCT')}</h3>
				</div>
				<div className="ReactModal__body">
					<div className="row">
						<div className="col col-sml-12 col-lrg-6">
							<BaasicDropdown dropdownStore={productDropdownStore} />
						</div>
						<div className="col col-sml-12 col-lrg-6">
							<BaasicInput field={addExistingProductForm.$('quantity')} showCheckmark={false} />
						</div>
						{addExistingProductForm.error && (
							<div className="col col-sml-12">
								<p className="type--color--warning spc--bottom--sml">{translate(addExistingProductForm.error)}</p>
							</div>
						)}
					</div>
				</div>
				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--bottom--sml" type="submit" disabled={isSaveClicked}>
						{t('SAVE')}
					</button>
					<button
						className="btn btn--med btn--ghost spc--bottom--sml"
						type="button"
						onClick={goBackToProductPartTypeSelection}
						disabled={isSaveClicked}
					>
						{t('BACK')}
					</button>
				</div>
			</form>{' '}
		</section>
	);
}

export default defaultTemplate(AddExistingProductModalContentTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/pages/AddExistingProductModalContentTemplate.jsx